import { Injectable } from '@angular/core';
import { version } from 'version';

@Injectable({
    providedIn: 'root',
})
export class TranslationCacheBusterService {
    getVersion(): string {
        return version;
    }

    getTranslationUrl(basePath: string, lang: string): string {
        const version = this.getVersion();
        return `${basePath}${lang}.json?v=${version}`;
    }
}
